<template>
    <v-container fluid fill-height class="text-center d-flex align-center justify-center changePswProfile"
        style="max-width: 300px;min-width:300px;">


        <v-form style="min-width:300px;" ref="form" v-model="valid" lazy-validation>

            <div v-if="!viewMobile">

                <v-avatar color="primary" size="56">
                    <span class="white--text text-h5">{{ initials }}</span>

                </v-avatar>
                <v-row class="text-center titlenewrow" style="">

                    <span>{{ namesurname }}</span>
                </v-row>

                <v-text-field v-model="profile.username" label="Utente" readonly></v-text-field>

                <div>

                    <v-text-field id="newPas" type="password" v-model="password" :rules="passwordRules"
                        label="Nuova password" required>
                    </v-text-field>
                    <img @click="showPassword" class="showpwd2" src="@/assets/icons8-eye-24.png" />

                </div>

                <div style="margin-top: -15px;">

                    <v-text-field type="password" id="confPas" v-model="rePassword" :rules="passwordConfirmationRule"
                        label="Conferma password" required>
                    </v-text-field>
                    <img @click="showPassword3" class="showpwd3" src="@/assets/icons8-eye-24.png" />

                </div>


                <div class="padding" style="min-height:100px;"></div>

            </div>

            <div v-if="viewMobile" style="margin-top: -180px;">

                <v-avatar color="primary" size="56">
                    <span class="white--text text-h5">{{ initials }}</span>

                </v-avatar>
                <v-row class="text-center titlenewrow" style="">

                    <span>{{ namesurname }}</span>
                </v-row>

                <v-text-field v-model="profile.username" label="Utente" readonly></v-text-field>

                <div>

                    <v-text-field id="newPas" type="password" v-model="password" :rules="passwordRules"
                        label="Nuova password" required>
                    </v-text-field>
                    <img @click="showPassword" class="showpwd2" src="@/assets/icons8-eye-24.png" />

                </div>

                <div style="margin-top: -15px;">

                    <v-text-field type="password" id="confPas" v-model="rePassword" :rules="passwordConfirmationRule"
                        label="Conferma password" required>
                    </v-text-field>
                    <img @click="showPassword3" class="showpwd3" src="@/assets/icons8-eye-24.png" />

                </div>


                <div class="padding" style="min-height:100px;"></div>



            </div>


        </v-form>
    </v-container>
</template>



<script>
import apiprofile from "../utils/profile/apiprofile";

import { bus } from "../main";
import router from ".././router";

import $ from 'jquery';


export default {
    destroyed() {
        this.$root.$children[0].bnavbuttons = [];

        bus.$off("bottomIconClickEvent");
        //window.removeEventListener("scroll", this.onScroll, false);

        //document.querySelector('#btn_add_tms').removeEventListener('click' , this.btn_add_tms_click);
    },




    mounted: function () {

        /*     let self = this;
            fetch('https://jsonplaceholder.typicode.com/posts')
              .then(response => response.json())
              .then(json => self.$data.items = json) */

        this.$root.$children[0].checkLogout();

        //var res = apiprofile.getProfile(1,2);
        setTimeout(() => {
            this.syncProfile();
            //  var username = window.$cookies.get("username");
            // this.profile.username = username ;


        }, 100);
        // console.log (res);


        bus.$on("bottomIconClickEvent", (data) => {
            //this.header = data;
            console.log(data);
            switch (data) {
                case "btn_save_password":
                    //alert("btn_add_tms");
                    this.validate();

                    break;

                case "btn_exit":
                    //alert("btn_add_x");
                    router.push({ path: "/dash" });
                    break;

                case "btn_back":
                    router.push({ path: "/profile" });
                    break;



                default:
                    break;
            }
        });

        this.setupButtons();

        this.getVersionMobile();
    },
    data: () => ({


        viewMobile: false,

        rePassword: "",
        oldpassword: "",
        password: "",





        passwordRules: [
            (v) => !!v || "Campo richiesto",
            (value) => (value && value.length >= 8) || 'minimo 8 caratteri',
            (value) => (value && /[A-Z]/.test(value)) || 'Almeno un carattere maiuscolo',
            (value) => (value && /[a-z]/.test(value)) || 'Almeno un carattere minuscolo',
            (value) => (value && /[0-9]/.test(value)) || 'Almeno un numero',
            (value) => (value && /[!@#$%^&*+]/.test(value)) || 'Almeno un carattere speciale ! @ # $ % ^ & * +',
        ],

        passwordConfirmationRule: [
            (v) => !!v || "Campo richiesto",
            (value) => (value && value.length >= 8) || 'minimo 8 caratteri',
            (value) => (value && /[A-Z]/.test(value)) || 'Almeno un carattere maiuscolo',
            (value) => (value && /[a-z]/.test(value)) || 'Almeno un carattere minuscolo',
            (value) => (value && /[0-9]/.test(value)) || 'Almeno un numero',
            (value) => (value && /[!@#$%^&*+]/.test(value)) || 'Almeno un carattere speciale ! @ # $ % ^ & * +',
        ],



        showPicker: false,
        profile: {},
        valid: true,
        initials: "",
        namesurname: "",
        iban: "",
        cellulare: "",
        codicefiscale: "",



        codicefiscaleRules: [
            (v) => !!v || "Codice fiscale is required",
            (v) => (v && v.length <= 16) || "Codice fiscale must be less than 16 characters",
        ],
        cellulareRules: [
            (v) => !!v || "Phone number is required",
            (v) => (v && v.length <= 30) || "Phone number must be less than 15 characters",
        ],
        genRules: [
            (v) => !!v || "Campo richiesto",

        ],
        ibanRules: [
            (v) => !!v || "Iban is required",
            (v) => (v && v.length <= 30) || "Iban must be less than 30 characters",
        ],
        email: "",
        emailRules: [
            (v) => !!v || "E-mail is required",
            (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
        ],
        select: null,
        items: ["Item 1", "Item 2", "Item 3", "Item 4"],
        checkbox: false,
    }),

    methods: {

        getVersionMobile: function () {

            this.viewMobile = false;

            if (window.innerWidth <= 768) {

                this.viewMobile = true;

            }


        },


        showPassword() {

            var newPasType = $("#newPas").attr("type");

            console.log(newPasType);

            if (newPasType == "password") {
                $("#newPas").attr("type", "text");
            }
            else {
                $("#newPas").attr("type", "password");
            }

        },


        showPassword3() {

            var confPasType = $("#confPas").attr("type");

            console.log(confPasType);

            if (confPasType == "password") {
                $("#confPas").attr("type", "text");
            }
            else {
                $("#confPas").attr("type", "password");
            }



        },




        setupButtons: async function () {



            setTimeout(() => {
                // console.log ("here we go" , this.$root.$children[0].drawer ) ;
                //window.App.$children[0].setToolbar();
                //   this.$root.$children[0].setToolbar();

                var pulsantis = [
                    {
                        text: "Save",
                        icon: "mdi-content-save",
                        link: "/timesheet",
                        id: "btn_save_password",
                        disabled: false,
                        image: "https://app.emtool.eu/public/_lib/img/icon_save_emt.png",
                        title: "Salva",
                        width: 30

                    },

                    {
                        text: "Indietro",
                        icon: "mdi-arrow-left",
                        image: "https://app.emtool.eu/public/_lib/img/back-emt.png",
                        link: "/tipologiapagamento",
                        id: "btn_back",
                        disabled: false,
                        title: "Indietro",
                        width: 35
                    },



                    // {
                    //   text: "Dashboard",
                    //   icon: "mdi-home-circle",
                    //   link: "/dash",
                    //   id: "btn_exit",
                    //   disabled: false,
                    // },


                ];
                //window.App.$children[0].bnavbuttons = pulsantis;
                this.$root.$children[0].bnavbuttons = pulsantis;

                //   this.$root.$children[0].$refs.btn_add_tms;

                // console.log( "ok" ,  this.$root.$refs.mainApp );
                //this.$root.$refs.mainApp.bnavbuttons = pulsantis;

                //   refs.btn_add_tms
                // console.log ("Refs" , this.$root.$children[0].$refs.btn_add_tms );

                // var refs = this.$root.$children[0].$refs.btn_add_tms ;

                //   var add_tms = refs.btn_add_tms ;

                //d console.log(this.$root.$children[0].$refs.btn_add_tms);
                setTimeout(() => {
                    //document.querySelector('#btn_add_tms').addEventListener('click',  this.btn_add_tms_click)
                    //this.$root.$children[0].$refs.btn_add_tms.$el.addEventListener('click', this.onClick);
                }, 100);

                // this.$root.$children[0].$refs.btn_add_tms[0].$el.addEventListener('click', this.onClick);
            }, 100);



        },
        savePassword: async function () {

            var username = window.$cookies.get("username");
            var token_system = window.$cookies.get("token_system");
            this.showSpinner = true;
            this.$root.$children[0].showProgress = true;

            var response;

            console.log(username, token_system);
            try {


                this.profile.oldpassword = this.oldpassword;
                this.profile.newpassword = this.password;


                response = await apiprofile.savePasswordNew(
                    username,
                    token_system,
                    this.profile
                );
            } catch (error) {
                this.showSpinner = false;
                console.log(error);
                //alert ( error.message);

                this.$swal({
                    icon: "error",
                    text: error.message,
                    showConfirmButton: false,
                    timer: 2000
                });


                //   this.$swal({ icon: "error", text: "Old password doesn't match" });


            }

            this.showSpinner = false;
            this.$root.$children[0].showProgress = false;

            try {

                console.log(response.data.Result);

                this.$swal({
                    icon: "success",
                    text: "La password è stata cambiata con successo",
                    showConfirmButton: false,
                    timer: 2000
                });



                setTimeout(() => {



                    console.log("PSW NEW", this.password);

                    var v_enc_psw = btoa(this.password);

                    console.log("ENC PSW NEW", v_enc_psw);

                    window.$cookies.set("token_system", v_enc_psw, "9y");

                    this.$root.$children[0].refreshMenu();


                    router.push({
                        path: "/profile"
                    });

                }, 300);


                /*     this.profile = this.iban = response.data.Result;
                       //console.log("HERE",response.data.Result.iban);
                    this.iban = response.data.Result.iban ;
                    this.email = response.data.Result.mail ;
                    this.codicefiscale = response.data.Result.codice_fiscale ;
                    this.cellulare = response.data.Result.tel_cell ;
                    this.namesurname = response.data.Result.name + " " + response.data.Result.surname  ;
                    this.initials = response.data.Result.name.charAt(0) + "" + response.data.Result.surname.charAt(0)  ; */

                //this.monthArray = response.data.Timesheet;


            } catch (error) {
                console.log(error);
            }

            //  this.data.days = response.data ;
        },




        syncProfile: async function () {
            /*  var token = window.$cookies.get("token");
             var system = window.$cookies.get("system"); */

            setTimeout(async () => {


                var username = window.$cookies.get("username");
                var token_system = window.$cookies.get("token_system");
                var v_token = window.$cookies.get("token");

                //   console.log ( system );
                this.showSpinner = true;
                this.$root.$children[0].showProgress = true;


                /*     var prove ;
                    try {
                
                        prove = await apiprofile.getProfile(
                            username,
                            token_system
                            );
                
                    } catch (error) {
                        alert ( error.message );
                        console.log(prove);
                
                    } */




                var result;
                try {
                    result = await apiprofile.getProfileEmt(
                        username,
                        token_system,
                        v_token
                    ).then((response) => {
                        // alert ("finshed");

                        // console.log (response);
                        this.showSpinner = false;
                        this.$root.$children[0].showProgress = false;

                        try {

                            this.profile = response.data.Result;
                            this.profile.username = username;
                            this.initials = response.data.Result.nome_utente.charAt(0) + "" + response.data.Result.cognome_utente.charAt(0);

                        } catch (error) {
                            console.log(error);
                            alert(error.message);
                        }

                        console.log(result);




                    });
                } catch (error) {
                    alert(error.message);

                    this.showSpinner = false;
                    this.$root.$children[0].showProgress = false;
                }

            }, 300);

            //  this.data.days = response.data ;
        },



        btn_add_tms_click() {
            console.log(1);
        },
        /*          onClick() {
          console.log('a phone number was clicked');
        }
    ,
     */
        reply(par) {
            console.log(par);
        },
        validate() {
            //this.$root.$children[0].showProgress = true;

            var res = this.$refs.form.validate();
            console.log(res);
            if (!res) {

                this.$swal({
                    icon: "error",
                    text: "Per favore verificare i dati",
                    showConfirmButton: false,
                    timer: 2000
                });

            } else {

                // console.log("Profile: ", this.profile);

                // this.savePassword();

                var errore = "";

                if (this.password != this.rePassword) {

                    errore = "Le password non corrispondono";

                }


                if (errore == "") {

                    console.log("ok");

                    this.savePassword();

                }
                else {

                    this.$swal({
                        icon: "error",
                        text: errore,
                        showConfirmButton: false,
                        timer: 3000
                    });



                }


            }
        },



        reset() {
            this.$refs.form.reset();
        },
        resetValidation() {
            this.$refs.form.resetValidation();
        },
    },
};
</script>

<style scoped>
.titlenewrow {
    justify-content: center;
    padding-top: 25px;
    padding-bottom: 30px;
    font-weight: bolder;

}

.v-sheet.v-card:not(.v-sheet--outlined) {
    box-shadow: none;
}
</style>

<style>
.changePswProfile .v-label {
    font-size: 11px !important;
    color: black !important;
    font-weight: bold !important;
}


.changePswProfile .v-input {
    font-size: 11px !important;
    padding: 10px !important;
    color: black !important;
    font-weight: bold !important;
}

.changePswProfile ion-select {
    font-size: 11px !important;
    color: black !important;
    font-weight: bold !important;
}

img.showpwd2 {
    max-width: 22px;
    cursor: pointer;
    transform: translate(122px, -59px);
}

img.showpwd3 {
    max-width: 22px;
    cursor: pointer;
    transform: translate(122px, -59px);
}
</style>